/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

export const FOCUS_TRENDS_CBG_DATE_TRACE = 'FOCUS_TRENDS_CBG_DATE_TRACE';
export const FOCUS_TRENDS_CBG_SLICE = 'FOCUS_TRENDS_CBG_SLICE';
export const FOCUS_TRENDS_SMBG = 'FOCUS_TRENDS_SMBG';
export const FOCUS_TRENDS_SMBG_RANGE_AVG = 'FOCUS_TRENDS_SMBG_RANGE_AVG';

export const MARK_SETTINGS_VIEWED = 'MARK_SETTINGS_VIEWED';
export const MARK_TRENDS_VIEWED = 'MARK_TRENDS_VIEWED';

export const SHOW_CBG_DATE_TRACES = 'SHOW_CBG_DATE_TRACES';

export const TOGGLE_SETTINGS_SECTION = 'TOGGLE_SETTINGS_SECTION';

export const TURN_OFF_CBG_RANGE = 'TURN_OFF_CBG_RANGE';
export const TURN_ON_CBG_RANGE = 'TURN_ON_CBG_RANGE';

export const UNFOCUS_TRENDS_CBG_DATE_TRACE = 'UNFOCUS_TRENDS_CBG_DATE_TRACE';
export const UNFOCUS_TRENDS_CBG_SLICE = 'UNFOCUS_TRENDS_CBG_SLICE';
export const UNFOCUS_TRENDS_SMBG = 'UNFOCUS_TRENDS_SMBG';
export const UNFOCUS_TRENDS_SMBG_RANGE_AVG = 'UNFOCUS_TRENDS_SMBG_RANGE_AVG';

// from blip's redux implementation
// TODO: how could we DRY this out??

export const FETCH_PATIENT_DATA_SUCCESS = 'FETCH_PATIENT_DATA_SUCCESS';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';

/**
 * Web Worker action types
 */

// pdf generation
export const GENERATE_PDF_REQUEST = 'GENERATE_PDF_REQUEST';
export const GENERATE_PDF_SUCCESS = 'GENERATE_PDF_SUCCESS';
export const GENERATE_PDF_FAILURE = 'GENERATE_PDF_FAILURE';

export const REMOVE_GENERATED_PDFS = 'REMOVE_GENERATED_PDFS';



/** WEBPACK FOOTER **
 ** ./src/redux/constants/actionTypes.js
 **/